// extracted by mini-css-extract-plugin
export default {"newsLinks":"index_newsLinks_oNWUT","bg":"index_bg_NUKuG"};